import { LinkFormattingService } from './link-formatting.service';

/**
 * Holds the root LinkFormattingService instance for Quill modules (non-DI context).
 */
export class LinkFormattingServiceHolder {
  private static _service: LinkFormattingService | null = null;

  static set service(value: LinkFormattingService) {
    LinkFormattingServiceHolder._service = value;
  }

  static get service(): LinkFormattingService | null {
    return LinkFormattingServiceHolder._service;
  }
}
